export default defineNuxtPlugin((nuxtApp) => {
    const platformSettings = usePlatformSettings();
    const baseUrl = useBaseUrl();

    const setRequestHeaders = (headers: any, token?: string) => {

      const theHeaders = headers ? headers : {};
      const platform = platformSettings.platformName;
      const countryCode = platformSettings.countryCode;
      const locale = platformSettings.locale;

      // We check what type of headers we have, and add the necessary headers
      // The Fetch API specification allows headers to be provided in these different formats, therefore the check
      if (Array.isArray(theHeaders)) {
        if (token) {
          theHeaders.push(['Authorization', `Bearer ${token}`]);
        }
        theHeaders.push(['Cache-Control', 'no-cache']);
        theHeaders.push(['accept-language', locale.value]);
        theHeaders.push(['moveable-platform', platform.value]);
        theHeaders.push(['moveable-countrycode', countryCode.value]);
      } else if (theHeaders instanceof Headers) {
        if (token) {
          theHeaders.set('Authorization', `Bearer ${token}`);
        }
        theHeaders.set('Cache-Control', 'no-cache');
        theHeaders.set('accept-language', locale.value);
        theHeaders.set('moveable-platform', platform.value);
        theHeaders.set('moveable-countrycode', countryCode.value);
      } else if (typeof theHeaders === 'object' && theHeaders !== null) {

        const typedHeaders = theHeaders as any;

        if (token) {
          typedHeaders['Authorization'] = `Bearer ${token}`;
        }
        typedHeaders['Cache-Control'] = 'no-cache';
        typedHeaders['accept-language'] = locale.value;
        typedHeaders['moveable-platform'] = platform.value;
        typedHeaders['moveable-countrycode'] = countryCode.value;
      }
    };

    const api = $fetch.create({
        baseURL: baseUrl.value,
        async onRequest({ request, options, error }) {
          const {
            loggedIn,
            session,
            clear: clearSession,
            fetch: fetchSession
          } = useUserSession();

          if (loggedIn.value) {
            const accessToken = session.value.jwt?.accessToken;
            const refreshToken = session.value.jwt?.refreshToken;

            if (!accessToken || !refreshToken) {
              console.warn('No access or refresh token available, clearing session');
              await clearSession();
              navigateTo('/logout');
              return;
            }

            const { tokenIsExpired } = useAuth();

            if (accessToken && refreshToken) {
              const accessTokenExpired = tokenIsExpired(accessToken);
              const refreshTokenExpired = tokenIsExpired(refreshToken);

              // If both tokens expired, clear the session and redirect to logout page
              if (accessTokenExpired && refreshTokenExpired) {
                await clearSession();
                navigateTo('/logout');
                return;
              }
              // if only access token expired, refresh it
              else if (accessTokenExpired) {
                console.info('Access token expired, refreshing...');
                await useRequestFetch()('/api/jwt/refresh');
                await fetchSession();
              }
            } else {
              console.warn('No access or refresh token available, clearing session');
              await clearSession();
              navigateTo('/logout');
              return;
            }
          }

          const token = session.value.jwt?.accessToken;
          setRequestHeaders(options.headers, token);
        }
      })
    ;

    return {
      provide: {
        api
      }
    };
  }
);
